import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.qtdPaginas, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: item.valor
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["w-6 h-6 ml-1 rounded-sm shadow-lg", {'bg-primary': item.selecionado}])
        }, [
          _createElementVNode("button", {
            class: _normalizeClass(["ml-2", {'text-white': item.selecionado}]),
            onClick: ($event: any) => (_ctx.atualizarSelecionado(index))
          }, _toDisplayString(item.valor), 11, _hoisted_2)
        ], 2)
      ]))
    }), 128))
  ]))
}